<template>
  <footer class="footer" v-if="$route.name !== 'Lanzamiento'">
    <div class="footer__inner">
      <p>
        NO ES NECESARIO COMPRAR. <br />
        No es válido donde esté prohibido. Abierto solamente a ciudadanos o residentes de Bogota, Colombia que tengan al menos 18 años de edad. <br />
        Concurso se realiza del  del 11 al 31 de enero de 2021. 
        <br />
        Este concurso no implica un casting ni participación en el programa SHARK TANK COLOMBIA ni tampoco se ofrece ningún tipo de inversión por parte de un Shark.  <br />
        Organizador: AXN Colombia Networks, S.A.S.. Patrocinador: Asesorías CC
        S.A.S.
      </p>

      <div class="menu">
        <div class="social">
          <a href="https://www.facebook.com/DiDiColombia/" target="_blank">
            <img src="@/assets/images/facebook_2.png" alt="DiDi Shark Tank" />
          </a>
          <a href="https://www.youtube.com/channel/UC4043jVyl39si8xvI99v5ww" target="_blank">
            <img src="@/assets/images/youtube_2.png" alt="DiDi Shark Tank" />
          </a>
          <a href="https://twitter.com/didicolombia" target="_blank">
            <img src="@/assets/images/twitter_2.png" alt="DiDi Shark Tank" />
          </a>
          <a href="https://www.instagram.com/didicolombia/" target="_blank">
            <img src="@/assets/images/instagram_2.png" alt="DiDi Shark Tank" />
          </a>
        </div>

        <a href="https://didiglobal.onelink.me/dPsa/d84d9524" target="_blank"> Descarga DiDi Pasajero </a>
        <a href="https://uniandes.edu.co/" target="_blank"> Universidad de los Andes </a>
        <a
          href="https://colombia.didiglobal.com/aviso-privacidad-pasajero/"
          target="_blank"
        >
          Política de Privacidad
        </a>
      </div>

      <img src="@/assets/images/logo_shark_tank.png" alt="DiDi Shark Tank" />
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.footer {
  background: #000000;
  padding: 4rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  @include phone {
    padding: 2rem 0;
  }

  &__inner {
    width: 80%;
    display: flex;
    flex-direction: column;
    align-items: center;

    @include phone {
      width: 90%;
    }

    p {
      font-family: "Montserrat", sans-serif;
      font-weight: normal;
      color: #ffffff;
      text-align: center;
      font-size: 0.85rem;
      line-height: 1.2em;
    }
    img {
      width: 45%;

      @include phone {
        width: 100%;
      }
    }

    .menu {
      width: 100%;
      margin: 2rem 0;
      display: flex;
      align-items: center;
      justify-content: space-between;

      @include phone {
        flex-direction: column;
      }

      .social {
        display: flex;
        @include phone {
          margin-bottom: 1rem;
        }

        a:not(:last-child) {
          margin-right: 1rem;
        }
        img {
          width: 15px;
          height: 15px;
          object-fit: contain;

          @include phone {
            width: 30px;
            height: 30px;
          }
        }
      }

      a {
        color: $main-color;
        text-decoration: none;

        @include phone {
          margin-bottom: 5px;
          &:last-of-type {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
</style>